import type { RevisionFile } from '../types';

/**
 * Quick compare two files.
 * Return true if different.
 */
export function compareFiles(f1: RevisionFile, f2: RevisionFile): boolean {
    return (
        f1.downloadURL !== f2.downloadURL ||
        f1.size !== f2.size ||
        f1.name !== f2.name ||
        f1.contentType !== f2.contentType ||
        f1.id !== f2.id
    );
}
